import { Gender } from '@verantos/shared-enums';

export const genderResponseMap: { [x: string]: string } = {
  m: Gender.Male,
  f: Gender.Female,
  male: Gender.Male,
  female: Gender.Female,
};
